import Vue from 'vue'
import Vuex from 'vuex'
import VuePersistence, { VuexPersistence } from 'vuex-persist'

Vue.use(Vuex)

const VuexLocal = new VuexPersistence({
  storage: window.localStorage,
})

const getters = {
  ACAO: (state: any) => {
    return state.acao
  },

  ATIVO: (state: any) => {
    return state.ativo
  },

  SHOW: (state: any) => {
    return state.show
  },

  TEXTO: (state: any) => {
    return state.texto
  },

  TEXTO_ACAO: (state: any) => {
    return state.textoAcao
  },
}

const actions = {}

const mutations = {
  ACAO (context: any, acao) {
    context.acao = acao
  },

  ATIVO (context: any, ativo) {
    context.ativo = ativo
  },

  SHOW (context: any, show) {
    context.show = show
  },

  TEXTO (context: any, texto) {
    context.texto = texto
  },

  TEXTO_ACAO (context: any, textoAcao) {
    context.textoAcao = textoAcao
  },
}

export default new Vuex.Store({
  state: {
    acao: '',
    ativo: false,
    show: false,
    texto: '',
    textoAcao: '',
  },
  getters: getters,
  actions: actions,
  mutations: mutations,
  plugins: [
    VuexLocal.plugin,
  ]
})
